import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { getPriceValidities, getSellerId, updateAllOfferValidity, getMaterialLocationFilterList } from "../../utils/api";
import { toast } from "react-toastify";

const OfferFilters = ({ offerEndTime, openFilters, openAddOffer, filters,
    setFilters }) => {

    const [areaOptions, setAreaOptions] = useState([]);

    const [timeLeft, setTimeLeft] = useState(null);
    const [validities, setValidities] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const seller = getSellerId();



    useEffect(() => {
        loadValidities();
    }, []);

    useEffect(() => {

        const loadAreas = async () => {
            try {
                const seller = getSellerId();
                const res = await getMaterialLocationFilterList(seller);

                const mapped = (res?.data || []).map(o => ({
                    value: o.id,
                    label: o.name
                }));

                setAreaOptions(mapped);
            } catch (err) {
                console.error("Area load failed", err);
            }
        };

        loadAreas();

        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const formatValidity = (time) => {
        const hours = parseInt(time.split(":")[0], 10);
        return `${hours} ${hours === 1 ? "Hour" : "Hours"}`;
    };

    const loadValidities = async () => {
        try {
            const res = await getPriceValidities();
            setValidities(res?.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSelect = async (val) => {
        try {
            if (!seller) {
                toast.error("Seller not found");
                return;
            }

            await updateAllOfferValidity({
                seller_id: seller,
                price_validity: val
            });

            toast.success("Validity updated");
            setShowDropdown(false);

            window.location.reload();

        } catch (err) {
            toast.error("Failed");
        }
    };

    useEffect(() => {

        if (!offerEndTime) {
            setTimeLeft(0);
            return;
        }

        const timer = setInterval(() => {

            const now = new Date().getTime();
            const end = new Date(offerEndTime).getTime();

            const diff = end - now;

            setTimeLeft(diff > 0 ? diff : 0);

        }, 1000);

        return () => clearInterval(timer);

    }, [offerEndTime]);

    const formatTime = () => {

        if (!timeLeft || timeLeft <= 0) return "00:00:00";

        const totalSeconds = Math.floor(timeLeft / 1000);

        const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
        const s = String(totalSeconds % 60).padStart(2, "0");

        return `${h}:${m}:${s}`;
    };

    return (

        <div className="card filter-card">

            <div className="filter-row">

                <button
                    className="filter-btn invisible absolute"
                    onClick={openFilters}
                >
                    Filters
                </button>

                <div className="filter-row">

                    {/* ✅ AREA DROPDOWN (no classname changes) */}
                    <Select
                        options={areaOptions}
                        value={
                            filters?.area
                                ? {
                                    value: filters.area.id,
                                    label: filters.area.name
                                }
                                : null
                        }
                        onChange={(selected) =>
                            setFilters(prev => ({
                                ...prev,
                                area: selected
                                    ? { id: selected.value, name: selected.label }
                                    : null
                            }))
                        }
                        isClearable
                        isSearchable
                        placeholder="Select Area"
                    />

                    {/* 👇 EXISTING TIMER */}
                    <div className="relative" ref={dropdownRef}>

                        <div
                            className="offer-timer cursor-pointer w-[9em] self-stretch"
                            onClick={() => setShowDropdown(prev => !prev)}
                        >
                            ⏰ {formatTime()}
                        </div>

                        {showDropdown && (
                            <div className="absolute right-0 mt-2 w-fit bg-white border rounded-lg shadow z-50">

                                {validities.map(v => (
                                    <div
                                        key={v.id}
                                        onClick={() => handleSelect(v.price_validity)}
                                        className="px-1 py-1 text-sm hover:bg-gray-100 cursor-pointer"
                                    >
                                        {formatValidity(v.price_validity)}
                                    </div>
                                ))}

                            </div>
                        )}

                    </div>

                    <button className="btn-primary" onClick={openAddOffer}>
                        Add New Offer
                    </button>

                </div>

            </div>
        </div>
    );
};

export default OfferFilters;